import { render, staticRenderFns } from "./RateLimiters.vue?vue&type=template&id=695c7cbd"
import script from "./RateLimiters.vue?vue&type=script&lang=js"
export * from "./RateLimiters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports